import { useMemo } from 'react';
import { withStyles, Icon, SelectRenderOptionArgs } from 'vopay';
import styles from './SelectOptionLocked.module.scss';

const classes = withStyles(styles);

type ComponentProps = SelectRenderOptionArgs & {
  onClick?: () => void;
  children: React.ReactNode;
  featureKey: string;
  disabled?: boolean;
  // Feature-local copy of the portal's SelectOptionLocked: locked state comes
  // in as a prop instead of the portal's LockedFeatures provider, and a locked
  // click is handed to the host (which may show its upsell dialog) instead of
  // the portal's LockedFeatureDialogue provider.
  lockedSelectOptions?: { [featureKey: string]: string };
  onLockedFeature?: (featureKey: string) => void;
};

function SelectOptionLocked({
  Option,
  SelectedIcon,
  children,
  onClick,
  preventDefault,
  selected,
  featureKey,
  disabled,
  lockedSelectOptions,
  onLockedFeature,
}: ComponentProps) {
  const locked = useMemo(() => lockedSelectOptions && featureKey in lockedSelectOptions, [lockedSelectOptions]);

  return (
    <Option
      onClick={() => {
        if (locked) {
          preventDefault();
          onLockedFeature?.(featureKey);
          onClick && onClick();
        } else if (disabled) {
          preventDefault();
          onClick && onClick();
        }
      }}
      className={classes((locked || disabled) && 'locked')}
    >
      <div className={classes('left')}>
        {locked && <Icon width="min-content" height="min-content" icon="lock2" size="sm" bgColor="primary-light" />}
        {children}
      </div>

      {selected && <SelectedIcon />}
    </Option>
  );
}

export default SelectOptionLocked;
